// Create an object for all query keys to ensure consistency
export const queryKeys = {
  // Brainstorming
  brainstorming: ['brainstorming'],
  brainstormingItem: (id) => ['brainstorming', id],
  
  // Users
  users: ['users'],
  adminUsers: ['users', 'admin'],
  user: (id) => ['users', id],
  currentUser: ['users', 'me'],
  userRoles: ['users', 'me', 'roles'],
  userSettings: ['users', 'me', 'settings'],
  userTimezone: ['users', 'me', 'timezone'],
  
  // Tenant
  tenant: ['tenant'],
  pursuitConnectStatus: ['pursuit-connect', 'status'],
  
  // Companies
  companies: ['companies'],
  company: (id) => ['companies', id],
  
  // Contacts
  contacts: ['contacts'],
  contact: (id) => ['contacts', id],
  
  // Tags
  tags: ['tags'],
  
  // Roles
  roles: ['roles'],
  usersByRole: (roleId) => ['roles', roleId, 'users'],
  
  // Actions
  actions: ['actions'],
  action: (id) => ['actions', id],
  actionsByPursuit: (pursuitId) => ['actions', 'pursuit', pursuitId],
  
  // Comments
  comments: ['comments'],
  commentsByPursuit: (pursuitId) => ['comments', 'pursuit', pursuitId],
  commentsByContact: (contactId) => ['comments', 'contact', contactId],
  
  // Business sectors
  businessSectors: ['business-sectors'],
  
  // Pursuits
  pursuits: ['pursuits'],
  pursuit: (id) => ['pursuits', id],
  pursuitContacts: (id) => ['pursuit-contacts', id],
  
  // Trashcan (soft deleted items)
  trashcan: ['trashcan'],
  
  // Pursuit stages
  pursuitStages: ['pursuit-stages'],

  // Item Categories
  itemCategories: ['item-categories'],
  itemSubcategories: (categoryId) => ['item-subcategories', categoryId],
  allSubcategories: ['all-subcategories'],
  
  // Items
  items: ['items'],
  item: (id) => ['items', id],
  itemUsers: ['items', 'users'],
  activeUsers: ['users', 'active'],
  endorserUsers: ['users', 'endorsers'],
  
  // Tasks
  tasks: ['tasks'],
  task: (id) => ['tasks', id],
  tasksByParent: (parentId) => ['tasks', 'parent', parentId],
  taskComments: (taskId) => ['task-comments', taskId],
  
  // Documents
  documents: ['documents'],
  documentsByItem: (itemId) => ['documents', 'item', itemId],
  document: (id) => ['documents', id],
  documentDuplicate: (itemId, filename) => ['documents', 'duplicate', itemId, filename],
  documentVersions: (documentId) => ['documents', 'versions', documentId],
  
  // Workflow Stages
  workflowStages: ['workflow-stages'],
  workflowStage: (id) => ['workflow-stages', id],
  
  // Stage Field Mappings
  stageFieldMappings: ['stage-field-mappings'],
  
  // Choices
  detectabilityChoices: ['choices', 'detectability'],
  scheduleChoices: ['choices', 'schedule'],
  originatingDisciplineChoices: ['choices', 'originating-discipline'],
  rootCauseCategoryChoices: ['choices', 'root-cause-category'],
  opportunityThreatChoices: ['choices', 'opportunity-threat'],
  typeChoices: ['choices', 'type'],
  riskTypeChoices: ['choices', 'risk-type'],
  assignedDisciplineChoices: ['choices', 'assigned-discipline'],
  probabilityChoices: ['choices', 'probability'],
  costChoices: ['choices', 'cost'],
  allChoices: ['choices', 'all'],
  
  // Risk Matrix
  riskMatrix: ['risk-matrix'],
  
  // User Views
  userViews: (tableName) => ['user-views', tableName],
  userView: (id) => ['user-views', id],

  // Reports
  staleItemsReport: (params) => ['reports', 'stale-items', params],

  // Audit Logs
  auditLogs: (params) => ['audit-logs', params],
};

// Common query configuration
export const defaultQueryOptions = {
  staleTime: 1000 * 60 * 5, // 5 minutes
  retry: (failureCount, error) => {
    // Don't retry on 4xx errors (client errors)
    if (error?.status >= 400 && error?.status < 500) {
      return false;
    }
    // Retry up to 3 times for other errors
    return failureCount < 3;
  },
  refetchOnWindowFocus: false,
};

// Create query options with defaults
export function createQueryOptions(queryKey, queryFn, options = {}) {
  return {
    queryKey,
    queryFn,
    ...defaultQueryOptions,
    ...options,
  };
}

// Common mutation configuration
export const defaultMutationOptions = {
  retry: false,
  onError: (error) => {
    console.error('Mutation error:', error);
  },
};

// Query client configuration
export const queryClientConfig = {
  defaultOptions: {
    queries: defaultQueryOptions,
    mutations: defaultMutationOptions,
  },
};

// Create mutation options with defaults
export function createMutationOptions(mutationFn, options = {}) {
  return {
    mutationFn,
    ...defaultMutationOptions,
    ...options,
  };
}